// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"settings_wrapper__LfTRP","card":"settings_card__2wTgC","title":"settings_title__1DO_v","close-btn":"settings_close-btn__3PnZC"};